import { NavLink } from "react-router-dom";
import {
  apiClusterInternalLinks,
  getApiTestingClusterPage,
} from "../content/apiTestingCluster";
import "../style/manualTestingCluster.css";

export default function ApiTestingClusterPage({ slug }) {
  const page = getApiTestingClusterPage(slug);

  if (!page) {
    return null;
  }

  return (
    <article className="manual-cluster-page">
      <div className="manual-cluster-intro">
        <span>API Testing Cluster</span>
        <p>
          This guide is part of QA Coder&apos;s API testing SEO cluster. Use it
          with manual testing, automation testing, and interview preparation to
          understand real backend validation clearly.
        </p>
      </div>

      {page.sections.map((section) => (
        <section className="manual-cluster-section" id={section.id} key={section.id}>
          <h2>{section.heading}</h2>

          {section.paragraphs?.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}

          {section.list && (
            <ul>
              {section.list.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}

          {section.faqs && (
            <div className="manual-cluster-faq">
              {section.faqs.map((faq) => (
                <details key={faq.question}>
                  <summary>{faq.question}</summary>
                  <p>{faq.answer}</p>
                </details>
              ))}
            </div>
          )}
        </section>
      ))}

      <section className="manual-cluster-links" aria-label="Related QA Coder learning links">
        <h2>Continue learning</h2>
        <p>
          Connect API testing with manual testing fundamentals, automation
          practice, and interview preparation so your QA skill path stays complete.
        </p>
        <div>
          {apiClusterInternalLinks.map((link) => (
            <NavLink to={link.to} key={link.to}>
              {link.label}
            </NavLink>
          ))}
        </div>
      </section>
    </article>
  );
}
